exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selected-color[data-v-3162124c] {\n\tcolor: #00a1e4;\n}\n.wardrobe-color[data-v-3162124c] {\n\tdisplay: inline-block;\n\twidth: 36px;\n\theight: 36px;\n\tborder-radius: 100%;\n\tborder: 3px solid white;\n}\n", ""]);

// exports
